"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Obcina początkowe i końcowe spacje w tekscie
 * @param text tekst do obcięcia
 */
function trim(text) {
    return (text || '').trim();
}
exports.default = trim;
//# sourceMappingURL=trim.js.map